import React from "react";
import InnerHeader from "../components/innerHeader";


const General = () => {
    return (
        <>
           <InnerHeader value='General Page' />

           <section className='generalSec'>
                <div className='custom-container'>
                    <div className='general_inner'>
                        
                    </div>
                </div>
            </section> 
        </>
    )
}
export default General;